import { render, staticRenderFns } from "./ModalCookiesPolicy.vue?vue&type=template&id=499cc822&scoped=true&"
import script from "./ModalCookiesPolicy.vue?vue&type=script&lang=js&"
export * from "./ModalCookiesPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ModalCookiesPolicy.vue?vue&type=style&index=0&id=499cc822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499cc822",
  null
  
)

export default component.exports